import type { DownloadManifest, DownloadTask } from './types';

export const MANIFEST_NAME = '.downloaded.json';

export function manifestKey(task: Pick<DownloadTask, 'shotId' | 'versionId'>): string {
  return `${task.shotId}_${task.versionId}`;
}

export function manifestSource(task: Pick<DownloadTask, 'videoURL' | 'sourceKey'>): string {
  return task.sourceKey ?? task.videoURL;
}

export function isRecorded(manifest: DownloadManifest, task: DownloadTask): boolean {
  const rec = manifest[manifestKey(task)];
  return !!rec && rec.videoURL === manifestSource(task);
}

export async function loadManifest(root: FileSystemDirectoryHandle): Promise<DownloadManifest> {
  try {
    const fh = await root.getFileHandle(MANIFEST_NAME, { create: false });
    const file = await fh.getFile();
    const parsed: unknown = JSON.parse(await file.text());
    return parsed && typeof parsed === 'object' ? (parsed as DownloadManifest) : {};
  } catch {
    return {};
  }
}

export async function saveManifest(root: FileSystemDirectoryHandle, manifest: DownloadManifest): Promise<void> {
  const fh = await root.getFileHandle(MANIFEST_NAME, { create: true });
  const writable = await fh.createWritable();
  await writable.write(JSON.stringify(manifest, null, 2));
  await writable.close();
}
